/* happyhug · Gutschein-PDP (sections/hh-gutschein-*.liquid)
   - Betrag waehlen: Preis, Cover-Vorschau und Druckbogen ziehen mit,
     ?variant= in der URL wird aktualisiert.
   - In den Warenkorb: ueber das Theme-Event theme:cart:add (Drawer wie auf
     jeder PDP). Ohne Theme-Script sendet das Formular normal an /cart/add.
   - Thumbs: erstes = Live-Vorschau, danach Produktbilder.
   - Druckbogen: Papierfarbe umschalten, QR-Code ueber vendor/qrcode.js. */
(function () {
  'use strict';

  var form = document.querySelector('[data-hhg-form]');
  var stage = document.querySelector('[data-hhg-stage]');
  var preview = stage && stage.querySelector('[data-hhg-preview]');
  var stageImg = stage && stage.querySelector('[data-hhg-stage-img]');
  var thumbs = document.querySelector('[data-hhg-thumbs]');

  function showPreview() {
    if (!preview || !stageImg) return;
    preview.hidden = false;
    stageImg.hidden = true;
    if (thumbs) {
      Array.prototype.forEach.call(thumbs.children, function (b, i) {
        b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      });
    }
  }

  function showImage(btn) {
    if (!preview || !stageImg) return;
    stageImg.src = btn.getAttribute('data-src');
    stageImg.srcset = btn.getAttribute('data-srcset') || '';
    stageImg.sizes = '(min-width: 900px) 560px, 100vw';
    stageImg.alt = btn.getAttribute('data-alt') || '';
    stageImg.hidden = false;
    preview.hidden = true;
  }

  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      Array.prototype.forEach.call(thumbs.children, function (b) {
        b.setAttribute('aria-current', b === btn ? 'true' : 'false');
      });
      if (btn.hasAttribute('data-src')) showImage(btn);
      else showPreview();
    });
  }

  function setAmount(input) {
    var label = input.getAttribute('data-label');
    var cover = input.getAttribute('data-cover');
    document.querySelectorAll('[data-hhg-price]').forEach(function (el) { el.textContent = label; });
    document.querySelectorAll('[data-hhg-mini]').forEach(function (el) { el.textContent = cover; });
    document.querySelectorAll('.hhg .gs-f-price').forEach(function (el) { el.textContent = cover; });
    document.querySelectorAll('.hhg .gs-b-value').forEach(function (el) {
      el.textContent = el.textContent.replace(/\d[\d.,]*\s?€/, label);
    });
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (err) { /* egal */ }
  }

  if (form) {
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'id') return;
      setAmount(e.target);
      showPreview();
    });

    form.addEventListener('submit', function (e) {
      // Wie jede PDP ueber das Theme-Event. Der Theme-Warenkorb ruft darauf
      // preventDefault(); fehlt er, geht das Formular normal an /cart/add.
      e.preventDefault();
      var ev = new CustomEvent('theme:cart:add', {
        detail: { button: form.querySelector('[data-add-to-cart]') },
        bubbles: false,
        cancelable: true
      });
      document.dispatchEvent(ev);
      if (!ev.defaultPrevented) form.submit();
    });
  }

  /* Druckbogen: Papierfarbe */
  document.querySelectorAll('[data-hhg-sheets]').forEach(function (sec) {
    var paper = sec.querySelector('[data-hhg-paper]');
    sec.addEventListener('change', function (e) {
      if (!e.target.matches('[data-hhg-paper-input]') || !paper) return;
      paper.setAttribute('data-paper', e.target.value);
    });
  });

  /* Druckbogen auf dem Handy: Punkte als Wisch-Hinweis */
  document.querySelectorAll('[data-hhg-sheets]').forEach(function (sec) {
    var row = sec.querySelector('.hhg-sheets__row');
    var dots = sec.querySelectorAll('[data-hhg-sheet-dots] button');
    if (!row || !dots.length) return;
    var items = row.querySelectorAll('.hhg-sheets__item');
    function sync() {
      var i = Math.round(row.scrollLeft / Math.max(1, row.scrollWidth - row.clientWidth) * (items.length - 1)) || 0;
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    row.addEventListener('scroll', sync, { passive: true });
    dots.forEach(function (d, j) {
      d.addEventListener('click', function () {
        if (items[j]) row.scrollTo({ left: items[j].offsetLeft - row.offsetLeft - (row.clientWidth - items[j].offsetWidth) / 2, behavior: 'smooth' });
      });
    });
  });

  /* QR-Code auf der Bogen-Rueckseite (vendor/qrcode.js von Shopify) */
  function drawQr() {
    if (typeof window.QRCode !== 'function') return false;
    document.querySelectorAll('.hhg [data-gs-qr]').forEach(function (el) {
      if (el.getAttribute('data-gs-qr-done')) return;
      var opts = { text: el.getAttribute('data-gs-qr'), width: 256, height: 256, colorDark: '#000000', colorLight: '#ffffff' };
      if (window.QRCode.CorrectLevel) opts.correctLevel = window.QRCode.CorrectLevel.H;
      new window.QRCode(el, opts);
      el.setAttribute('data-gs-qr-done', '1');
      el.querySelectorAll('img').forEach(function (img) { img.alt = ''; });
    });
    return true;
  }
  if (!drawQr()) window.addEventListener('load', drawQr);
})();
